export default function Search() {
	// Find the search trigger element and the mobile search wrapper element
	const searchTrigger = document.querySelector('.js-search-trigger');
	const searchWrapper = document.querySelector('.js-search-wrapper');

	if (searchTrigger && searchWrapper) {
		const icon = searchTrigger.querySelector('ion-icon')

		// Add a click event listener to the search trigger
		searchTrigger.addEventListener('click', function() {
			searchWrapper.classList.toggle('active')

			const isOpen = searchWrapper.classList.contains('active')
			searchTrigger.setAttribute('aria-expanded', String(isOpen))
			searchTrigger.setAttribute('aria-label', isOpen ? 'Close search' : 'Search')

			if (isOpen) {
				document.querySelector('.js-live-search-input').focus()
			}

			if (icon) {
				if (icon.getAttribute('name') === 'search-sharp') {
					icon.setAttribute('name', 'close-sharp')
				} else {
					icon.setAttribute('name', 'search-sharp')
				}
			}
		});
	}
}